import React, { useEffect } from "react";
import { isAllDayBasedOnTimes } from "../../web-app-calendar/hooks/useEditExistingEvent.util";
import { useReadEventTimeDetails, useUpdateEventTimeDetails } from "../hooks/EventCardContext";
import { AllDayToggle } from "../proposals/AllDayToggle";

export const AllDay = ({
  readOnly,
  showChanges = false,
}: {
  readOnly: boolean;
  showChanges?: boolean;
}) => {
  const { startTime, endTime, isAllDay } = useReadEventTimeDetails();
  const { setIsAllDay, setTimeError } = useUpdateEventTimeDetails();

  // Determine if new times make the event "all day"
  const isAllDayFromTimes = isAllDayBasedOnTimes(startTime, endTime);

  useEffect(() => {
    setIsAllDay(isAllDayFromTimes);
  }, [isAllDayFromTimes, setIsAllDay]);

  const onToggleIsAllDay = (newVal: boolean) => {
    setIsAllDay(newVal);
    if (newVal) {
      const isSameDay = endTime ? startTime?.hasSame(endTime, "day") : false;
      if (isSameDay) {
        setTimeError("All day events must have different start and end dates");
      }
    }
  };

  return (
    <AllDayToggle
      isAllDay={isAllDay}
      onChange={onToggleIsAllDay}
      readOnly={readOnly}
      showChanges={showChanges}
    />
  );
};
